import {useContext, useEffect, useState} from "react";
import {useLocation, useParams, useSearchParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
// import {getProductsByCategory} from "../../api/catalog";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import BreadcrumbInterface from "../../interfaces/core/BreadcrumbInterface";
import {CatalogFilterInterface} from "../../interfaces/catalog/CatalogFilterInterface";
import CatelogBase from "./CatalogBase";
import {getProductsByCategory} from "../../api/catalog";
import useYandexMetrika from "../../utils/useYandexMetrika";

type QueryDataParams = {
    categoryId: string
}

export default function CatalogByPath() {

    const [filters, setFilters] = useState<CatalogFilterInterface>({price: {min: 0, max: 0}, filters: {}, brands: []});
    const location = useLocation();


    useEffect(() => {
        setFilters({price: {min: 0, max: 0}, filters: {}, brands: []})
    }, [location]);

    const queryData = useParams<QueryDataParams>();


    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const {reachGoal} = useYandexMetrika();

    const {data: response, status} = useQuery({
        queryKey: [queryData.categoryId, state.customer?.id],
        queryFn: () => getProductsByCategory(queryData.categoryId as string, state.customer),
        //@ts-ignore
        retry: !window.NOSCRIPT ? false : 1
    })

    useEffect(() => {
        switch (status) {
            case 'pending':
                dispatch({type: ReducerActionType.LOAD})
                return;
            case 'error':
                dispatch({type: ReducerActionType.ERROR, payload: 'При загрузке товаров возникли ошибки'})
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS})
                return;
        }
    }, [status]);

    useEffect(() => {
        if (!response?.category.name) {
            return;
        }

        let breadcrumbs: BreadcrumbInterface[] = [];

        if ((response?.parentCategories?.length || 0) > 0) {
            breadcrumbs = response?.parentCategories?.map((item) => {
                return {
                    name: item.full_name,
                    url: '/catalog/list/' + item.catalog_code + '/' + item.human_url
                }
            }) as BreadcrumbInterface[];
        }
        if (response?.category.name) {
            breadcrumbs.push({
                name: response?.category.name,
                url: '/catalog/list/' + response?.category.catalog_code + '/' + response?.category.human_url
            })
        }

        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: breadcrumbs})

        reachGoal('category', {
            id: response.category.catalog_code,
            name: response.category.name,
            customer_id: state.customer?.id,
            customer_name: state.customer?.name,
        });

    }, [response]);


    return (<>{response && <CatelogBase response={response} header={response?.category?.name} baseUrl={'/catalog/list/' + response?.category?.catalog_code + '/' + response?.category?.human_url} />}</>);
}